export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border border-slate-300",
  generated: "bg-blue-50 text-blue-700 border border-blue-200",
  completed: "bg-green-50 text-green-700 border border-green-200",
  cancelled: "bg-red-50 text-red-700 border border-red-200",
  active: "bg-green-50 text-green-700 border border-green-200",
  inactive: "bg-slate-100 text-slate-500 border border-slate-300",
};

export default function StatusBadge({ status }) {
  const s = (status || "draft").toLowerCase();
  return (
    <span className={`badge capitalize ${STATUS_STYLES[s] || STATUS_STYLES.draft}`} data-testid={`status-${s}`}>
      {s}
    </span>
  );
}
